<template>
  <div class="news-detail">
    <!-- 头部导航组件 -->
    <header-cmp></header-cmp>
    <menu-cmp></menu-cmp>
    <!-- pc端 -->
    <section class="news-detail-center">
      <Breadcrumb :fromPath="fromPath" />
      <div class="news-detail-center-top">
        <div class="news-detail-center-top-left">
          <img
            src="http://zhongtian.ezhangxiu.cn/attached/user/company/202204/d6/d6d5ff305f58d421cbf2c97b20fca843.jpg"
            alt=""
          />
          <div class="news-detail-center-content">
            <div class="title">
              中国田径协会中国田径协会中国田径协会中国田径协会中国田径协中国田径协会中国田径协会中国田径协会中国田径协会中国田径协
            </div>
            <div class="author">
              <div>2019-8-13 16:04:43</div>
              <div class="author-desc">中国田径协会</div>
            </div>
            <div class="message">
              为进一步做好中国田径项目巴黎奥运会的备战工作，广泛汇聚国际精英人才，实现中国田径队全项参赛的目标，中国田径协会拟面向全球招募优秀的教练员、物理治疗师及体能师，现将有关情况公告如下：
              一、具体招募人员岗位职责及要求 (一)田径项目教练员 岗位职责
              1、根据中国田径协会对各田径项目制定的巴黎奥运会参赛目标，制定中国运动员巴黎奥运会周期备战方案、年度训练规划、日常训练计划，明确每年度国际大赛的任务目标。
              2、根据制定的训练计划，组织中国运动员完成各项日常训练。针对运动员管理提出合理建议，逐步提高运动员的竞技水平。随中国田径队参加国内国际比赛，以最佳表现完成比赛，并达到既定目标。
              3、负责协助中国田径协会联系并安排中国运动员出国训练和比赛；协助联系国外训练基地及科技助力方面支持。
              4、完成所带中国运动员世锦赛、亚运会等重要国际比赛的参赛目标，并最终完成巴黎奥运会参赛目标。
              任职要求 1、基本条件：
              (1)遵守中国的法律，具有良好的道德修养和职业操守；
              (2)具有为中国承担2024年巴黎奥运会备战任务的主观意愿；
              (3)未发生过严重兴奋剂违规问题； (4)无犯罪不良记录；
              (5)可以用英语进行流利对话，具有良好的表达及沟通能力；热爱田径项目，责任心强，具有团队合作精神。
              2、业绩条件：
              (1)上两个奥运周期内(2012年10月1日至2021年8月31日)所执教的运动员在世锦赛或奥运会上获得过奖牌。
              (2)上两个奥运周期内(2012年10月1日至2021年8月31日)所执教的运动员创造过世界年度最好成绩或获得过洲际冠军。
              (3)所执教的运动员获得过世锦赛或奥运会金牌、或创造过世界纪录。
              (二)物理治疗师 岗位职责
              1、负责国家队运动员运动损伤的预防、评估、治疗和康复工作；
              2、利用各类物理治疗手法和设备为运动员进行康复治疗与疲劳恢复工作；
              3、负责运动员训练过程中的医务监督工作，及时发现潜在损伤风险；
              4、能与专项教练、体能师以及科研人员协同工作;
              5、了解田径项目专项特点 任职要求 1、基本条件：
              (1)遵守中国的法律，具有良好的道德修养和职业操守；
              (2)具有为中国承担2024年巴黎奥运会备战任务的主观意愿；
              (3)未发生过严重兴奋剂违规问题； (4)无犯罪不良记录；
              (5)可以用英语进行流利对话，具有良好的表达及沟通能力；热爱田径项目，责任心强，具有团队合作精神。
              以上特此公告。
            </div>
          </div>
        </div>
        <div class="news-detail-center-top-right">
          <div class="classify">
            <div class="title">相关书籍</div>
            <ul>
              <li>检测中心检测中心检测中心检测中心检测中心检测中心检测中心</li>
              <li>短跑短跑短跑短跑短跑短跑短跑短跑短跑短跑短跑短跑短跑短跑</li>
              <li>
                国际奥委会国际奥委会国际奥委会国际奥委会国际奥委会国际奥委会
              </li>
              <li>器材科普器材科普器材科普器材科普器材科普器材科普器材科普</li>
              <li>新闻科普新闻科普新闻科普新闻科普新闻科普新闻科普新闻科普</li>
            </ul>
            <div class="buy">去购买</div>
            <div class="buymsg">购买单位和个人需扫描下方问卷星二维码</div>
            <img
              class="buyQr"
              src="http://zhongtian.ezhangxiu.cn/attached/user/company/202204/d6/d6d5ff305f58d421cbf2c97b20fca843.jpg"
            />
          </div>
        </div>
      </div>
    </section>
    <!-- 移动端 -->
    <section class="news-detail-center-mobile">
      <div class="content">
        <div class="title">
          中国田径协会中国田径协会中国田径协会中国田径协会中国田径协中国田径协会中国田径协会中国田径协会中国田径协会中国田径协
        </div>
        <div class="author-wrap">
          <div class="left">
            <div>来源：</div>
            <div class="author">田径协会田径场地</div>
          </div>
          <div class="right">
            <div class="date">2021.03.31</div>
          </div>
        </div>
        <div class="message">
          为进一步做好中国田径项目巴黎奥运会的备战工作，广泛汇聚国际精英人才，实现中国田径队全项参赛的目标，中国田径协会拟面向全球招募优秀的教练员、物理治疗师及体能师，现将有关情况公告如下：
          一、具体招募人员岗位职责及要求 (一)田径项目教练员 岗位职责
          1、根据中国田径协会对各田径项目制定的巴黎奥运会参赛目标，制定中国运动员巴黎奥运会周期备战方案、年度训练规划、日常训练计划，明确每年度国际大赛的任务目标。
          1、基本条件： (1)遵守中国的法律，具有良好的道德修养和职业操守；
          (2)具有为中国承担2024年巴黎奥运会备战任务的主观意愿；
          (3)未发生过严重兴奋剂违规问题； (4)无犯罪不良记录；
          (5)可以用英语进行流利对话，具有良好的表达及沟通能力；热爱田径项目，责任心强，具有团队合作精神。
          以上特此公告。
        </div>
        <div class="classify">
          <div class="title">相关书籍</div>
          <ul>
            <li>检测中心检测中心检测中心检测中心检测中心检测中心检测中心</li>
            <li>短跑短跑短跑短跑短跑短跑短跑短跑短跑短跑短跑短跑短跑短跑</li>
            <li>
              国际奥委会国际奥委会国际奥委会国际奥委会国际奥委会国际奥委会
            </li>
            <li>器材科普器材科普器材科普器材科普器材科普器材科普器材科普</li>
            <li>新闻科普新闻科普新闻科普新闻科普新闻科普新闻科普新闻科普</li>
          </ul>
          <div class="buy-wrap">
            <div class="buy">去购买</div>
            <div class="buymsg">购买单位和个人需扫描下方问卷星二维码</div>
            <img
              class="buyQr"
              src="http://zhongtian.ezhangxiu.cn/attached/user/company/202204/d6/d6d5ff305f58d421cbf2c97b20fca843.jpg"
            />
          </div>
        </div>
      </div>
    </section>
    <footer-cmp></footer-cmp>
  </div>
</template>
<script>
import headerCmp from "@/components/common/header.vue";
import menuCmp from "@/components/common/navMenu.vue";
import footerCmp from "@/components/common/footer.vue";
import Breadcrumb from "./components/Breadcrumb.vue";
export default {
  data() {
    return {
      fromPath: "",
    };
  },
  components: {
    headerCmp,
    menuCmp,
    footerCmp,
    Breadcrumb,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fromPath = from.path;
    });
  },
};
</script>
<style lang="scss" scoped>
@media screen and (min-width: 961px) {
  .news-detail {
    font-size: 14px;
    width: 100%;
    height: 100%;

    &-center {
      width: 1200px;
      margin: 0 auto;

      &-top {
        margin-bottom: 24px;
        display: flex;

        &-left {
          img {
            width: 790px;
            height: 427px;
            margin-right: 40px;
          }
        }

        &-right {
          .classify {
            display: flex;
            align-items: center;
            flex-direction: column;
            .title {
              font-size: 24px;
              font-weight: 500;
              color: #da5351;
              line-height: 33px;
              margin-bottom: 20px;
            }
            ul {
              margin-bottom: 24px;
              li {
                &::before {
                  content: "· ";
                }
                font-size: 16px;
                font-weight: 500;
                color: #333333;
                line-height: 22px;
                margin-bottom: 16px;
              }
            }
            .buy {
              background: linear-gradient(144deg, #ef8b89 0%, #da5351 100%);
              border-radius: 30px;
              font-size: 18px;
              font-weight: 400;
              color: #ffffff;
              padding: 7px 33px;
              margin-top: 20px;
            }
            .buymsg {
              font-size: 14px;
              font-weight: 400;
              color: #da5351;
              line-height: 20px;
              margin-top: 20px;
            }
            .buyQr {
              width: 164px;
              height: 164px;
              margin-top: 6px;
            }
          }
        }
      }

      &-content {
        width: 790px;

        .title {
          font-size: 34px;
          font-weight: 500;
          color: #333333;
          line-height: 46px;
          margin: 24px 0px 20px 0px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .author {
          display: flex;
          margin-bottom: 20px;
          font-size: 14px;
          font-weight: 400;
          color: #666666;
          line-height: 20px;
          &-desc {
            margin-left: 10px;
          }
        }

        .message {
          font-size: 16px;
          font-weight: 400;
          color: #454545;
          line-height: 24px;
          margin-bottom: 80px;
        }
      }
    }
  }

  .news-detail-center-mobile {
    display: none;
  }
}

@media screen and (max-width: 960px) {
  .news-detail-center {
    display: none;
  }

  .news-detail-center-mobile {
    height: 100%;
    position: relative;
    padding-top: 0.56rem;
    .content {
      margin: 0.24rem 0.16rem 0.4rem;
    }
    .title {
      font-size: 0.24rem;
      font-weight: 500;
      color: #454545;
      line-height: 0.3rem;
      text-overflow: ellipsis;
      -webkit-line-clamp: 2;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
    .author-wrap {
      margin: 0.1rem 0px 0.16rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .left {
        display: flex;
        font-size: 0.12rem;
        font-weight: 400;
        color: #666666;
        line-height: 0.14rem;
      }
      .right {
        display: flex;
        font-size: 0.12rem;
        font-weight: 400;
        color: #666666;
        line-height: 0.14rem;
        .number {
          margin: 0 0.04rem;
        }
      }
    }
    .message {
      font-size: 0.16rem;
      font-weight: 400;
      color: #454545;
      line-height: 0.22rem;
    }
    .classify {
      .title {
        padding: 0.24rem 0 0.16rem;
        font-size: 0.18rem;
        font-weight: 500;
        color: #333333;
        line-height: 0.24rem;
        border-bottom: 1px solid #f1f1f1;
      }
      ul {
        margin-top: 0.16rem;
        li {
          font-size: 0.14rem;
          font-weight: 400;
          color: #454545;
          line-height: 0.2rem;
          margin-bottom: 0.16rem;
          &::before {
            content: "·";
          }
        }
      }
      .buy-wrap {
        display: flex;
        flex-direction: column;
        align-items: center;
        .buy {
          font-size: 0.14rem;
          font-weight: 500;
          color: #cc3b3f;
          line-height: 0.2rem;
          border-radius: 0.15rem;
          border: 1px solid #cc3b3f;
          margin-top: 0.08rem;
          padding: 0.05rem 0.27rem;
        }
        .buymsg {
          font-size: 0.12rem;
          font-weight: 400;
          color: #da5351;
          line-height: 0.17rem;
          margin-top: 0.26rem;
        }
        .buyQr {
          width: 1.3rem;
          height: 1.3rem;
          margin-top: 0.12rem;
        }
      }
    }
  }
}
</style>